import { createContext, use } from 'react'
import { SessionStatus } from './reducer'

export interface SessionContextValue {
  status: SessionStatus
  deadline: number | null
  logout: () => void
  stayActive: () => void
}

export const SessionContext = createContext<SessionContextValue | null>(null)

export function useSession(): SessionContextValue {
  const context = use(SessionContext)
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider')
  }
  return context
}
